import { apiClient } from './client';

export async function getBillingModulePrices(params = {}) {
  const { data } = await apiClient.get('/api/system/billing/module-prices', { params });
  return data;
}

export async function getBillingModulePrice(id) {
  const { data } = await apiClient.get(`/api/system/billing/module-prices/${id}`);
  return data.data ?? data;
}

export async function createBillingModulePrice(payload) {
  const { data } = await apiClient.post('/api/system/billing/module-prices', payload);
  return data.data ?? data;
}

export async function updateBillingModulePrice(id, payload) {
  const { data } = await apiClient.put(`/api/system/billing/module-prices/${id}`, payload);
  return data.data ?? data;
}

export async function activateBillingModulePrice(id) {
  const { data } = await apiClient.patch(`/api/system/billing/module-prices/${id}/activate`);
  return data.data ?? data;
}

export async function deactivateBillingModulePrice(id) {
  const { data } = await apiClient.patch(`/api/system/billing/module-prices/${id}/deactivate`);
  return data.data ?? data;
}

export async function stripeSyncBillingModulePrice(id) {
  const { data } = await apiClient.post(`/api/system/billing/module-prices/${id}/stripe-sync`);
  return data;
}

export async function postPricingPreview(payload) {
  const { data } = await apiClient.post('/api/system/billing/pricing-preview', payload);
  return data.data ?? data;
}

export async function getBillingSmsUsage(params = {}) {
  const { data } = await apiClient.get('/api/system/billing/sms-usage', { params });
  return data;
}

export async function getTenantSmsUsage(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/sms-usage`, { params });
  return data;
}

export async function recalculateTenantSmsUsage(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/sms-usage/recalculate`, payload);
  return data.data ?? data;
}

export async function getTenantUserSeats(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/user-seats`);
  return data;
}

export async function getTenantModuleSubscriptions(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/module-subscriptions`);
  return data.data ?? data;
}

export async function updateTenantModuleSubscriptions(tenantId, payload) {
  const { data } = await apiClient.put(`/api/system/tenants/${tenantId}/module-subscriptions`, payload);
  return data;
}

export async function getPortalCustomerPricingSummary(customerId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/pricing-summary`);
  return data.data ?? data;
}

export async function getPortalTenantModuleSubscriptions(customerId, tenantId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/module-subscriptions`);
  return data.data ?? data;
}

export async function getPortalTenantSmsUsage(customerId, tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/sms-usage`, { params });
  return data.data ?? data;
}
